var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_527_8946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0C37.2552 0 48 10.7448 48 24C48 37.2552 37.2552 48 24 48C10.7448 48 0 37.2552 0 24C0 10.7448 10.7448 0 24 0ZM21.768 13.3944C21.3237 13.3944 20.8976 13.5709 20.5835 13.8851C20.2693 14.1992 20.0928 14.6253 20.0928 15.0696V28.464C20.0928 29.3904 20.8416 30.1392 21.768 30.1392H35.1624C35.3876 30.1477 35.6121 30.1107 35.8227 30.0305C36.0332 29.9502 36.2254 29.8282 36.3877 29.672C36.55 29.5157 36.6791 29.3282 36.7673 29.1209C36.8555 28.9135 36.901 28.6905 36.901 28.4652C36.901 28.2399 36.8555 28.0169 36.7673 27.8095C36.6791 27.6022 36.55 27.4147 36.3877 27.2584C36.2254 27.1022 36.0332 26.9802 35.8227 26.8999C35.6121 26.8197 35.3876 26.7827 35.1624 26.7912H23.4408V15.0696C23.4408 14.6257 23.2646 14.2 22.951 13.8859C22.6374 13.5718 22.2119 13.395 21.768 13.3944Z",
    fill: "#1A1C3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_527_8946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.9f3db88c90ea40fc4b68bec2b56c6626.svg";
export { ForwardRef as ReactComponent };